import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import OfertaCard from '../components/OfertaCard';
import './Blog.css';

const PostDetalhe = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [relatedOffer, setRelatedOffer] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/blog/${slug}`);
                const postData = response.data;
                setPost(postData);

                if (postData.relatedOfferId) {
                    try {
                        const offerResponse = await axios.get(`${process.env.REACT_APP_API_URL}/ofertas/${postData.relatedOfferId}`);
                        const o = offerResponse.data;
                        const transformedOffer = {
                            ...o,
                            precoOriginal: o.preco_original,
                            precoDesconto: o.preco_desconto,
                            imagem: o.imagem_url,
                            validade: o.data_validade,
                            link: o.link_afiliado
                        };
                        setRelatedOffer(transformedOffer);
                    } catch (err) {
                        console.error("Erro ao buscar oferta relacionada:", err);
                    }
                }
            } catch (error) {
                console.error('Erro ao buscar post:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchPost();
    }, [slug]);

    useEffect(() => {
        const handleCouponClick = (e) => {
            const couponElement = e.target.closest('[data-coupon]');
            if (couponElement) {
                const coupon = couponElement.getAttribute('data-coupon');
                navigator.clipboard.writeText(coupon);
                
                // Visual feedback
                const originalText = couponElement.innerText;
                couponElement.innerText = "COPIADO!";
                couponElement.style.backgroundColor = "#25D366";
                couponElement.style.color = "white";
                
                setTimeout(() => {
                    couponElement.innerText = originalText;
                    couponElement.style.backgroundColor = "";
                    couponElement.style.color = "";
                }, 2000);
            }
        };
        document.addEventListener('click', handleCouponClick);
        return () => document.removeEventListener('click', handleCouponClick);
    }, []);

    if (loading) {

        return <div className="container" style={{ padding: '100px', textAlign: 'center' }}>Carregando...</div>;
    }

    if (!post) {
        return <div className="container" style={{ padding: '100px', textAlign: 'center' }}>Post não encontrado.</div>;
    }

    return (
        <div className="post-detail-container">
            <Helmet>
                <title>{post.title} | Blog Ofertiz</title>
                <meta name="description" content={post.content.replace(/<[^>]*>/g, '').substring(0, 160)} />
            </Helmet>

            <header className="post-header" style={{ 
                backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.7)), url(${post.featuredImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '80px 0',
                color: 'white',
                marginBottom: '40px'
            }}>
                <div className="container">
                    <nav className="breadcrumbs light" style={{ marginBottom: '20px', fontSize: '14px', opacity: 0.9 }}>
                        <Link to="/" style={{ color: 'white' }}>Início</Link> &nbsp;&gt;&nbsp; 
                        <Link to="/blog" style={{ color: 'white' }}>Blog</Link> &nbsp;&gt;&nbsp; 
                        <span>{post.title}</span>
                    </nav>
                    <h1 style={{ fontSize: '2.5rem', marginBottom: '15px' }}>{post.title}</h1>
                    <div className="post-meta" style={{ display: 'flex', gap: '20px', fontSize: '14px' }}>
                        <span className="post-category" style={{ background: 'var(--primary-color)', padding: '4px 12px', borderRadius: '20px' }}>{post.category}</span>
                        <span className="post-date" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <i className="far fa-calendar-alt"></i>
                            {new Date(post.createdAt).toLocaleDateString('pt-BR')}
                        </span>
                    </div>
                </div>
            </header>

            <div className="container blog-content-layout">
                <main className="post-content-wrapper">
                    <div 
                        className="post-body" 
                        dangerouslySetInnerHTML={{ __html: post.content }} 
                    />
                </main>

                <aside className="post-sidebar">
                    {relatedOffer && (
                        <div className="related-offer-widget" style={{ marginBottom: '30px' }}>
                            <h3 style={{ fontSize: '1.2rem', marginBottom: '15px', borderBottom: '2px solid var(--primary-color)', paddingBottom: '8px' }}>
                                Oferta em Destaque
                            </h3>
                            <OfertaCard 
                                oferta={relatedOffer} 
                                isFavorite={false} 
                                onFavoriteToggle={() => {}} 
                            />
                        </div>
                    )}
                    
                    <div className="newsletter-widget" style={{ 
                        background: '#f8f9fa', 
                        padding: '25px', 
                        borderRadius: '12px', 
                        textAlign: 'center',
                        border: '1px solid #eee'
                    }}>
                        <i className="fab fa-whatsapp" style={{ fontSize: '3rem', color: '#25D366', marginBottom: '15px' }}></i>
                        <h3 style={{ marginBottom: '10px' }}>Receba Ofertas no WhatsApp</h3>
                        <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
                            Participe dos nossos grupos e não perca nenhuma promoção!
                        </p>
                        <a href="/join-whatsapp" className="btn-whatsapp-join" style={{
                            display: 'block',
                            background: '#25D366',
                            color: 'white',
                            padding: '12px',
                            borderRadius: '8px',
                            textDecoration: 'none',
                            fontWeight: 'bold',
                            transition: 'opacity 0.2s'
                        }}>
                            ENTRAR NO GRUPO
                        </a>
                    </div>
                </aside>
            </div>
        </div>
    );
};

export default PostDetalhe;
